import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "LANGUAGES/en/translation.json";
import translationJA from "LANGUAGES/ja/translation.json";
import store from "REDUX/store";
import { LANGUAGE } from "UTILS/Constants";

import { DEFAULT_LANGUAGE } from "UTILS/Constants";
import moment from 'moment';
import 'moment/locale/ja';

//The translations here for the japanese and english
const resources = {
  en: {
    translation: translationEN
  },
  ja: {
    translation: translationJA
  }
};

// 新しい言語バリアントのデータをサーバーから取得
const fetchTranslationData = async (tenantUrl) => {
  try {
    const response = await fetch(tenantUrl);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching translation data:", error);
    throw error;
  }
};

// reset resource JP translation words from wording files
export const resetResources = async() => {
  i18n.addResourceBundle("ja", "translation", translationJA ,false);
  moment.locale(DEFAULT_LANGUAGE);
  await i18n.changeLanguage(DEFAULT_LANGUAGE);
}

// 新しい言語バリアントのデータでi18n.jsのresources内の日本語のデータを上書きする関数
export const replaceTranslationDataToResources = async (setLanguage) => {
  try {
    const translationData = await fetchTranslationData(store.getState().OrganisationReducer.wordingUrl);
    i18n.addResourceBundle(LANGUAGE.JA.name, "translation", translationData, false);
    if(store.getState().LanguageReducer.language !== LANGUAGE.EN.name){
      moment.locale(LANGUAGE.JA.name);
      await i18n.changeLanguage(LANGUAGE.JA.name);
      // rendering function call
      if(setLanguage){
        // initialization
        setLanguage(LANGUAGE.EN.name);
        // update language
        setLanguage(LANGUAGE.JA.name);
      }

    }
  } catch (error) {
    console.error("Error adding translation data:", error);
  }
};

//function that will trigger when user want to change the language
export const changeLanguage = async (lang = store.getState().LanguageReducer.language) => {
  let nowLanguage = lang || DEFAULT_LANGUAGE;
  moment.locale(nowLanguage);
  await i18n.changeLanguage(nowLanguage);
};

//function to convert message in expected language
export const getMessage = (key, interpolation) => {
  return i18n.t(key, interpolation);
};

i18n.use(initReactI18next).init({
  resources : resources,
  lng: DEFAULT_LANGUAGE,
  nsSeparator: false,
  keySeparator: false, // we do not use keys in form messages.welcome
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});

export default i18n;
